const Temp = () => {
  // console.log()
  return (
    <div className="">
      <h1>RadheRadhe</h1>
    </div>
  );
};

export default Temp;
